<template>
  <div ref="gantt" class="left-container"></div>
</template>

<script>
import {gantt} from 'dhtmlx-gantt';
import "dhtmlx-gantt/codebase/dhtmlxgantt.css"

export default {
  name: "GanttComponent",

  props: {
    tasks: {
      type: Object,
      default() {
        return {data: [], links: []}
      }
    },
    dataValue: Object,
  },

  methods: {

    // 展开所有任务：
    expandAllS() {
      gantt.eachTask(function (task) {
        task.$open = true;
      });
      gantt.render();
    },

    // 折叠所有任务：
    unExpandAllS() {
      gantt.eachTask(function (task) {
        task.$open = false;
      });
      gantt.render();
    },

    // 全屏
    fullScreenS(){
      gantt.ext.fullscreen.toggle();
    },

    zoomINS() {
      // 获取当前等级
      const level = gantt.ext.zoom.getCurrentLevel()
      // 做一下判断，大于0才能放大
      if (level > 0) gantt.ext.zoom.setLevel(level - 1)
    },

    zoomOutS() {
      const level = gantt.ext.zoom.getCurrentLevel()
      if (level < 4) gantt.ext.zoom.setLevel(level + 1)
    },

    // 获取下标
    getArrayIndex(arr, obj) {
      let i = arr.length;
      while (i--) {
        if (arr[i] === obj) {
          return i;
        }
      }
      return -1;
    },
  },

  mounted: function () {

    //解决甘特图重绘页面数据叠加
    gantt.clearAll()
    // 缩放功能
    const hourToStr = gantt.date.date_to_str('%H:%i')
    const hourRangeFormat = function (step) {
      return function (date) {
        const intervalEnd = new Date(gantt.date.add(date, step, 'hour') - 1)
        return hourToStr(date) + ' - ' + hourToStr(intervalEnd)
      }
    }
    const zoomConfig = {
      minColumnWidth: 80,
      maxColumnWidth: 150,
      levels: [
        [
          {unit: 'month', format: '%M %Y', step: 1},
          {
            unit: 'week',
            step: 1,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str('%d %M')
              var endDate = gantt.date.add(date, -6, 'day')
              var weekNum = gantt.date.date_to_str('%W')(date)
              return 'Week #' + weekNum + ', ' + dateToStr(date) + ' - ' + dateToStr(endDate)
            }
          }
        ],
        [
          {unit: 'month', format: '%M %Y', step: 1},
          {unit: 'day', format: '%d %M', step: 1}
        ],
        [
          {unit: 'day', format: '%d %M', step: 1},
          {unit: 'hour', format: hourRangeFormat(12), step: 12}
        ],
        [
          {unit: 'day', format: '%d %M', step: 1},
          {unit: 'hour', format: hourRangeFormat(6), step: 6}
        ],
        [
          {unit: 'day', format: '%d %M', step: 1},
          {unit: 'hour', format: '%H:%i', step: 1}
        ]
      ],
      useKey: 'ctrlKey',
      trigger: 'wheel',
      element: function () {
        return gantt.$root.querySelector('.gantt_task')
      }
    }

    // gantt.ext.zoom.init(zoomConfig)

    const zoomConfigButton = {
      levels: [
        {
          name:"day",
          scale_height: 27,
          min_column_width:80,
          scales:[
            {unit: "day", step: 1, format: "%d %M"}
          ]
        },
        {
          name:"week",
          scale_height: 50,
          min_column_width:50,
          scales:[
            {unit: "week", step: 1, format: function (date) {
                var dateToStr = gantt.date.date_to_str("%d %M");
                var endDate = gantt.date.add(date, 6, "day");
                var weekNum = gantt.date.date_to_str("%W")(date);
                return "#" + weekNum + ", " + dateToStr(date) + " - " + dateToStr(endDate);
              }},
            {unit: "day", step: 1, format: "%j %D"}
          ]
        },
        {
          name:"month",
          scale_height: 50,
          min_column_width:120,
          scales:[
            {unit: "month", format: "%F, %Y"},
            {unit: "week", format: "Week #%W"}
          ]
        },
        {
          name:"quarter",
          height: 50,
          min_column_width:90,
          scales:[
            {unit: "month", step: 1, format: "%M"},
            {
              unit: "quarter", step: 1, format: function (date) {
                const dateToStr = gantt.date.date_to_str("%M");
                const endDate = gantt.date.add(gantt.date.add(date, 3, "month"), -1, "day");
                return dateToStr(date) + " - " + dateToStr(endDate);
              }
            }
          ]},
        {
          name:"year",
          scale_height: 50,
          min_column_width: 30,
          scales:[
            {unit: "year", step: 1, format: "%Y"}
          ]}
      ]
    };

    gantt.ext.zoom.init(zoomConfigButton);

    // gantt.message({
    //   text: '使用 <b>ctrl + 滚轮</b> 进行缩放',
    //   expire: -1
    // })

    //左侧是否自适应
    gantt.config.autofit = true;
    //左侧宽
    // gantt.config.grid_width = 200;

    gantt.config.open_split_tasks = true;
    // 只读
    gantt.config.readonly = true

    // 格式化时间
    gantt.config.date_format = '%Y-%m-%d'
    // 国际化-中文
    gantt.i18n.setLocale('cn')
    // 显示tooltip
    gantt.plugins({
      tooltip: true,
      // 全屏
      fullscreen: true,
    })

    //鼠标移上去提示
    gantt.templates.tooltip_text = function (start, end, task) {
      return (
          "<b>名称:</b> " +
          task.text +
          "<br/><span><b>计划开始时间:</b></span> " +
          gantt.templates.tooltip_date_format(start) +
          "<br/><span><b>计划结束时间:</b></span> " +
          gantt.templates.tooltip_date_format(new Date(end.valueOf() -1))
          // "<br/><span>进度:</span> " +
          // Math.round(task.progress * 100) +
          // "%"
      );
    };

    // 禁用弹窗（双击任务不再出现弹窗）
    gantt.attachEvent('onBeforeLightbox', function (id) {
      return false
    })

    let table = this.dataValue
    console.log(table + '>>>')
    let ids = table.columnInfo.ids
    //名称下标
    let nameSub = this.getArrayIndex(ids,1054001)
    console.log(nameSub)
    // 项目分类下标
    let typeSub = this.getArrayIndex(ids,1054006)
    // 计划开始时间下标
    let startSub = this.getArrayIndex(ids,1054009)
    // 计划结束时间下标
    let finishSub = this.getArrayIndex(ids,1054010)
    // 项目经理下标
    let managerSub = this.getArrayIndex(ids,1054003)
    // 负责人下标
    let personChargeSub = this.getArrayIndex(ids,1054004)
    // 执行状态下标
    let executionStatusSub = this.getArrayIndex(ids,1054007)
    // 计划持续时间下标
    let durationSub = this.getArrayIndex(ids,1054011)

    let names = table.columnInfo.names
    //名称
    let name = names.at(nameSub)
    // 项目分类
    let type = names.at(typeSub)
    // 计划开始时间
    let start = names.at(startSub)
    // 计划结束时间
    let finish = names.at(finishSub)
    // 项目经理
    let manager = names.at(managerSub)
    // 负责人
    let personCharge = names.at(personChargeSub)
    // 执行状态
    let executionStatus = names.at(executionStatusSub)
    // 计划持续时间
    let duration = names.at(durationSub)

    // 客制化 列
    gantt.config.columns = [
      {name: 'wbs', label: 'WBS', width: 100, align: 'center'},
      {name: 'text', label: name, tree: true, width: 200, align: 'left'},
      {
        name: 'projectType',
        label: type,
        width: 80,
        align: 'center',
        template: function (obj) {
          if (obj.projectType === '项目') {
            return '项目'
          } else {
            return '任务'
          }
        }
      },
      {name: 'start_date', label: start, width: 80, align: 'center'},
      {name: 'end_date', label: finish, width: 80, align: 'center'},
      {name: 'projectManager', label: manager, width: 120, align: 'center'},
      {name: 'director', label: personCharge,width: 120,align: 'center'},
      {name: 'executionStatus', label: executionStatus, width: 60, align: 'center',},
      {name: 'span', label: duration, width: 120, align: 'center'},
    ]

    gantt.templates.task_end_date = function(date){
      return gantt.templates.task_date(new Date(date.valueOf() - 1));
    };

    let gridDateToStr = gantt.date.date_to_str("%Y-%m-%d");
    gantt.templates.grid_date_format = function(date, column){
      if(column === "end_date"){
        return gridDateToStr(new Date(date.valueOf() - 1));
      }else{
        return gridDateToStr(date);
      }

    }

    // 初始化
    gantt.init(this.$refs.gantt)
    // 甘特图数据
    gantt.parse(this.$props.tasks)
  }

}
</script>

<style scoped>
</style>
